export default "__VITE_ASSET__DrYQHWMl__"